/**
 * @file This file contains the main configuration for the Merge Village game,
 * including keys for various non-biome-specific items and characters.
 * @module mergeVillageConfig
 */

/**
 * The main configuration object for the Merge Village game.
 * @type {Object}
 * @property {string[]} animalKeys - An array of keys for generic animal items.
 * @property {string[]} upgradeableGenericKeys - An array of keys for generic items that can be upgraded.
 * @property {string[]} stationaryObjectKeys - An array of keys for stationary obstacle items.
 * @property {string[]} npcCharactersKeys - An array of keys for human NPC characters.
 * @property {string[]} nonHumanNpcCharactersKeys - An array of keys for non-human NPC characters.
 */
export const mergeVillageConfig = {
    scoring: {
        baseMerge: 10,
        chestMerge: 250,
        powerupClearBase: 10,
        powerupClearBonus: 10
    },
    mechanics: {
        megaMergeThreshold: 9,
        megaMergeTierBonus: 1,
        weatherIdleTimeout: 20000, // 2 minutes in ms
        isDayNightCycleEnabled: false, // Master toggle for the day/night cycle
        isNpcTargetingEnabled: false, // Toggle for NPC target signposts
        babySpawnChance: 0.25, // Chance for a baby to be born when two NPCs fall in love
        npcSpawnWithItemChanceIfJobsExist: 0.5 // 50% chance to spawn WITH an item even if jobs exist.
    }
};